// 常规-航线列表接口
import req from './index'

//获取管线
export const getFlyRouteApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.FlyRoute_List', params)
}

//新增 | 编辑 管线
export const setRoutesApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.FlyRoute_Set', params)
}

//删除管线
export const delRoutesApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.FlyRoute_Del', params)
}

//临时执行
export const temporaryExecutionApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.FlyRoute_Execute', params)
}

// 导出管线、航点、标识桩
export const derivedInfoApi = (params) => {
  return req.get('api/admin.php?s=Admin.DockRoute.FlyRoute_Export', params)
}


// 修改警戒线状态
export const setStatusApi = (params) => {
  return req.get('api/admin.php?s=Admin.DockRoute.FlyRoute_Status', params)
}

// ----------------------------- 航线编辑 --------------------------------

//获取管道
export const GetRoutesPoint = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.PipeOverview_Get', params)
}
//获取航点
export const GetRoutesPoint111 = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.FlyRoutePoints_Get', params)
}

//获取航点以及航点动作
export const GetRoutesPointAction = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.FlyRoutePointActions_Get', params)
}

//获取管线详细信息 包括起飞点
export const GetRoutesInfo = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.FlyRoute_Info', params)
}

//根据经纬度获取海拔
export const GetAltitude = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.GetElev9', params)
}


// 获取地图中展示编辑与否的权限
export const getLimitsAuthorityInfo = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.GetMapLimitation', params)
}



// ------------------------------ 新接口 --------------------------------

// 获取所有机场信息
export const getAirportListApi = (params) => {
  return req.get('api/admin.php?s=Admin.DockRoute.Dock_List', params)
}


// 获取所有 管道信息
export const getPipingApi = (params) => {
  return req.get('api/admin.php?s=Admin.DockRoute.PipeOverview_Get', params)
}

// 获取 航线信息
export const getRoutesInfoApi = (params) => {
  return req.get('api/admin.php?s=Admin.DockRoute.FlyRoute_Info', params)
}

// 获取所有 航点及航点动作信息
export const getPointActionsApi = (params) => {
  return req.get('api/admin.php?s=Admin.DockRoute.FlyRoutePointActions_Get', params)
}

// 修改起飞点信息
export const setTakeOffInfoApi = (params) => {
  return req.get('api/admin.php?s=Admin.DockRoute.FlyRoute_TakeOff_Edit', params)
}

// 编辑航点动作
export const setPointActionsApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.FlyRoutesPointAction_Edit', params)
}

// 编辑航点动作
export const setPointApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.FlyRoutesPoint_Edit', params)
}


// 获取当前机场下 其他的航点信息
export const getOtherRoutesInfo = (params) => {
  return req.get('api/admin.php?s=Admin.DockRoute.FlyRoutesPoints_List', params)
}